import getUserLicenseType, { LicenseType } from '../utils/getUserLicenseType';
import isPremiumTemporarilyEnabled from '../selectors/isPremiumTemporarilyEnabled';

export default function isPremium(): boolean {
    return getUserLicenseType() === LicenseType.Subscription || isPremiumTemporarilyEnabled();
}
